module.exports = __webpack_public_path__ + "static/assets/3971dc998a657f0951ad83f579844911.svg";